import axios from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, getUrlFromUri, handleResponse} from 'Shared/utilities/fetchHelpers';

export const syncSchooxUserFromSchoox = async () => {
    const axiosConfig = getAxiosConfig();

    const response = await axios
    .post(getUrlFromUri(`/api/user/v1/syncSchooxUser`), null, {
        ...axiosConfig
    });

    return handleResponse(response);
};
